import { ObjectHelper } from 'Code/Helpers/ObjectHelper';

export class GridSettingsIncludesMultipleLayoutsBaseValueConverter {
    toView(gridSettings, configuration) {
        if (ObjectHelper.ObjectIs(gridSettings)) {
            return Object.keys(gridSettings).filter(key => key.startsWith(configuration.name)).length > 1;
        }
        return false;
    }
}